import { Card } from "@mui/material";
import muiStyles from "../styles/muiStyles";
import ImageUploader from "../../../Components/ImageUploader";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { generateCommunityAvatarUrl } from "../../../Utils/avatarUtils";

const UploadCommunityPicture = (props) => {
  const {
    imageUrl,
    setImageUrl,
    tempImageFile,
    setTempImageFile,
    setSubmitStatus,
    disableFields,
    setImageDeleted,
    initialImageUrl,
    avatarImgUrl,
    setAvatarImgUrl,
  } = props;

  const { values } = useFormikContext();

  const { t } = useTranslation("page-community-settings");

  const handleImageError = (message) => {
    setSubmitStatus({
      open: true,
      message: message || t("community_picture.errors.upload_failed"),
      severity: "error",
    });
  };

  useEffect(() => {
    if (values.community_name && !imageUrl && !tempImageFile) {
      const avatarUrl = generateCommunityAvatarUrl(values.community_name);
      setAvatarImgUrl(avatarUrl);
    }
    if (imageUrl || tempImageFile) {
      setAvatarImgUrl("");
    }
  }, [values.community_name, setAvatarImgUrl, imageUrl, tempImageFile]);

  const { cardStyles } = muiStyles;

  return (
    <Card sx={cardStyles}>
      <ImageUploader
        label={t("community_picture.title")}
        imageUrl={imageUrl}
        setImageUrl={setImageUrl}
        tempImageFile={tempImageFile}
        setTempImageFile={setTempImageFile}
        onError={handleImageError}
        isLoading={disableFields}
        maxSizeMB={15}
        hint={t("community_picture.instructions")}
        labelSx={{
          fontSize: "18px",
        }}
        imageStyle={{
          width: 110,
          height: 110,
          borderRadius: "50%",
          objectFit: "cover",
        }}
        initialImageUrl={initialImageUrl}
        onImageDelete={() => setImageDeleted(true)}
        resetImageDeleted={() => setImageDeleted(false)}
        avatarImgUrl={avatarImgUrl}
      />
    </Card>
  );
};

export default UploadCommunityPicture;
